var _circle, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRank9(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 14.3772,
    r: 13.5293,
    fill: "url(#paint0_linear_4229_8387)",
    stroke: "url(#paint1_linear_4229_8387)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8558 9.08174C15.4922 9.08174 16.1001 9.18591 16.6797 9.39424C17.2592 9.59879 17.7763 9.92644 18.2308 10.3772C18.6854 10.8242 19.0433 11.4132 19.3047 12.1442C19.5661 12.8753 19.6967 13.7673 19.6967 14.8204C19.7005 15.7901 19.5869 16.6594 19.3558 17.4283C19.1248 18.1935 18.7933 18.845 18.3615 19.3829C17.9335 19.9208 17.4183 20.3317 16.8161 20.6158C16.2138 20.8961 15.5414 21.0363 14.799 21.0363C13.9808 21.0363 13.2592 20.8791 12.6342 20.5647C12.013 20.2465 11.5149 19.8185 11.1399 19.2806C10.7687 18.7427 10.5471 18.1405 10.4751 17.4738H13.2422C13.3293 17.8602 13.513 18.1518 13.7933 18.3488C14.0736 18.542 14.4089 18.6386 14.799 18.6386C15.5111 18.6386 16.0433 18.3298 16.3956 17.7124C16.7479 17.095 16.924 16.256 16.924 15.1954H16.8558C16.6929 15.5439 16.4619 15.8431 16.1626 16.0931C15.8672 16.3431 15.5244 16.5344 15.1342 16.667C14.7441 16.7995 14.3331 16.8658 13.9013 16.8658C13.2043 16.8658 12.5888 16.7067 12.0547 16.3886C11.5244 16.0704 11.1077 15.6329 10.8047 15.0761C10.5054 14.5192 10.3539 13.8829 10.3501 13.167C10.3464 12.3639 10.5339 11.6556 10.9126 11.042C11.2914 10.4245 11.8198 9.94348 12.4979 9.59879C13.1759 9.2503 13.9619 9.07795 14.8558 9.08174ZM14.8729 11.2408C14.5244 11.2408 14.2138 11.3223 13.9411 11.4852C13.6721 11.648 13.46 11.8677 13.3047 12.1442C13.1494 12.4208 13.0736 12.7314 13.0774 13.0761C13.0812 13.4208 13.1589 13.7314 13.3104 14.0079C13.4657 14.2844 13.6759 14.5041 13.9411 14.667C14.21 14.8298 14.5168 14.9113 14.8615 14.9113C15.1191 14.9113 15.3577 14.8639 15.5774 14.7692C15.7971 14.6745 15.9884 14.5439 16.1513 14.3772C16.3142 14.2067 16.4411 14.0098 16.532 13.7863C16.6267 13.5628 16.6721 13.3242 16.6683 13.0704C16.6645 12.7333 16.585 12.4264 16.4297 12.1499C16.2744 11.8734 16.0604 11.6537 15.7876 11.4908C15.5187 11.3242 15.2138 11.2408 14.8729 11.2408Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4229_8387",
    x1: 15,
    y1: 0.3479,
    x2: 15,
    y2: 28.4065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AED8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B3E52"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4229_8387",
    x1: 15,
    y1: 0.3479,
    x2: 15,
    y2: 28.4065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDFBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11273D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRank9);
export default __webpack_public_path__ + "static/media/rank9.09398b585173c854dec523d057a503ae.svg";
export { ForwardRef as ReactComponent };